import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import permission from './modules/permission'
import diagnostic from './modules/diagnostic'
import register from './modules/register'
import dashboards from './modules/dashboard'
import screeing from './modules/screeing'
import setting from './modules/setting'
import statistic from './modules/statistic'

import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    diagnostic,
    register,
    screeing,
    dashboards,
    setting,
    statistic
  },
  getters
})

export default store
